'use client';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useState, useRef, useCallback, useId } from 'react';
import 'swiper/css';
import clsx from 'clsx';

import YoutubeCustom from './youtube';
import VideoCustom from './custom-video';
import { Title } from '../../title';
import { RectangleArrow } from '../../icons/rectangle-arrow';

const ACFVideosBlock = ({ data }) => {
  const sliderRef = useRef(null);

  const [prevDisabled, setPrevDisabled] = useState(true);
  const [nextDisabled, setNextDisabled] = useState(false);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    setNextDisabled(false);
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    setPrevDisabled(false);
    sliderRef.current.swiper.slideNext();
  }, []);

  const rawId = useId();
  const instanceId = `swiper-vid-${rawId.replace(/:/g, '')}`;

  const idPrev = `id-prev-${instanceId}`;
  const idNext = `id-next-${instanceId}`;

  const videosBlock = data?.videosBlock;

  if (!videosBlock) {
    return null;
  }

  return (
    <div className="videosBlock w-full px-0">
      <div className="topTen__header mb-4 flex items-center justify-between px-0">
        <Title
          variant="h4"
          text={videosBlock.title || 'Materiały wideo'}
          className="!mb-0 px-0 md:text-[18px] md:leading-[22px]"
        />

        {videosBlock.videos != null && videosBlock.videos.length > 1 && (
          <div className="flex items-center gap-2 px-0">
            <div
              className={clsx(
                'swiper-button-prev-custom relative static mt-0 h-auto w-auto shrink-0 cursor-pointer px-0 after:hidden',
                idPrev,
                prevDisabled ? 'swiper-button-disabled cursor-not-allowed opacity-50' : 'hover:opacity-80',
              )}
              onClick={handlePrev}
            >
              <RectangleArrow />
            </div>
            <div
              className={clsx(
                'swiper-button-next-custom relative static mt-0 h-auto w-auto shrink-0 cursor-pointer px-0 after:hidden',
                idNext,
                nextDisabled ? 'swiper-button-disabled cursor-not-allowed opacity-50' : 'hover:opacity-80',
              )}
              onClick={handleNext}
            >
              <RectangleArrow />
            </div>
          </div>
        )}
      </div>

      <Swiper
        ref={sliderRef}
        className={clsx(instanceId, 'px-0')}
        onReachEnd={() => setNextDisabled(true)}
        onReachBeginning={() => setPrevDisabled(true)}
        onSlideChange={(swiper) => {
          // Broadcast event with null ID so native HTML5 videos pause on swipe
          window.dispatchEvent(new CustomEvent('pauseAllVideos', { detail: { playingVideoId: null } }));

          // Re-evaluate button states explicitly on swipe
          setPrevDisabled(swiper.isBeginning);
          setNextDisabled(swiper.isEnd);
        }}
        modules={[Navigation]}
        spaceBetween={16}
        slidesPerView={1}
      >
        {videosBlock.videos != null &&
          videosBlock.videos.length > 0 &&
          videosBlock.videos.map((item, i) => (
            <SwiperSlide className="item px-0" key={i}>
              <div className="cover w-full px-0">
                {item?.videoExternal ? (
                  <YoutubeCustom item={item} />
                ) : item?.video?.node?.mediaItemUrl ? (
                  <VideoCustom item={item} />
                ) : (
                  <div className="flex aspect-video w-full items-center justify-center bg-[#242424] text-white px-0">
                    Brak wideo
                  </div>
                )}
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default ACFVideosBlock;
